import { rest } from "msw";
import { mockStockProducts } from "./stockProducts.mocks";
export const stockProductsHandlers = [
    rest.get("/product/commercial/stock", (req, res, ctx) => {
        const type = req.url.searchParams.get("type");
        const filteredItems = type
            ? mockStockProducts.items.filter((item) => item.type === type)
            : mockStockProducts.items;
        const totalStock = filteredItems.reduce((sum, item) => sum + item.stockNum, 0);
        const totalPrice = filteredItems.reduce((sum, item) => sum + (item.totalPrice ?? 0), 0);
        const response = {
            ...mockStockProducts,
            items: filteredItems,
            totalStock,
            totalPrice,
            total: filteredItems.length,
            pageCount: 1,
        };
        return res(ctx.json(response));
    }),
];
